import React, { useEffect, useState } from 'react';
import { css } from 'emotion';
import { parseBrazeEpicParams, } from '@root/src/web/lib/braze/parseBrazeEpicParams';
import { getBrazeMetaFromUrlFragment } from '@root/src/web/lib/braze/forceBrazeMessage';
import { useOnce } from '@root/src/web/lib/useOnce';
import { joinUrl } from '@root/src/lib/joinUrl';
import { useHasBeenSeen } from '@root/src/web/lib/useHasBeenSeen';
import { submitComponentEvent } from '@root/src/web/browser/ophan/ophan';
import { setAutomat } from '@root/src/web/lib/setAutomat';
const wrapperMargins = css `
	margin: 18px 0;
`;
const EPIC_COMPONENT_PATH = '/modules/v1/epics/ContributionsEpic.js';
export const canShow = async (brazeMessagesPromise) => {
    const forcedBrazeMeta = getBrazeMetaFromUrlFragment();
    if (forcedBrazeMeta) {
        return {
            result: true,
            meta: forcedBrazeMeta,
        };
    }
    try {
        const brazeMessages = await brazeMessagesPromise;
        const message = await brazeMessages.getMessageForEndOfArticle();
        return {
            result: true,
            meta: {
                dataFromBraze: message.extras,
                logImpressionWithBraze: () => {
                    message.logImpression();
                },
            },
        };
    }
    catch (e) {
        return { result: false };
    }
};
const buildEpicProps = (dataFromBraze, countryCode) => {
    const variant = parseBrazeEpicParams(dataFromBraze);
    if (variant === null)
        return null;
    const pageTracking = {
        ophanPageId: window.guardian.config.ophan.pageViewId,
        platformId: 'GUARDIAN_WEB',
        clientName: 'dcr',
        referrerUrl: window.location.origin + window.location.pathname,
    };
    const tracking = {
        ...pageTracking,
    };
    return { variant, tracking, numArticles: 0, countryCode };
};
const BrazeEpic = ({ contributionsServiceUrl, meta, countryCode, }) => {
    const [Epic, setEpic] = useState();
    const [hasBeenSeen, setNode] = useHasBeenSeen({
        rootMargin: '-18px',
        threshold: 0,
        debounce: true,
    });
    useOnce(() => {
        setAutomat();
        const componentUrl = joinUrl([
            contributionsServiceUrl,
            EPIC_COMPONENT_PATH,
        ]);
        window
            .guardianPolyfilledImport(componentUrl)
            .then((epicModule) => {
            setEpic(() => epicModule.ContributionsEpic); // useState requires functions to be wrapped
        })
            .catch((error) => {
            window.guardian.modules.sentry.reportError(error, 'braze-epic');
        });
    }, [contributionsServiceUrl, meta]);
    useEffect(() => {
        if (hasBeenSeen && meta && meta.dataFromBraze) {
            meta.logImpressionWithBraze();
            // Log VIEW event with Ophan
            submitComponentEvent({
                component: {
                    componentType: 'RETENTION_EPIC',
                    id: meta.dataFromBraze.ophanComponentId,
                },
                action: 'VIEW',
            });
        }
    }, [hasBeenSeen, meta]);
    if (Epic && meta.dataFromBraze) {
        // This will come from Braze via the meta from canShow
        const props = buildEpicProps(meta.dataFromBraze, countryCode);
        if (props) {
            return (React.createElement("div", { ref: setNode, className: wrapperMargins },
                React.createElement(Epic, Object.assign({}, props))));
        }
    }
    return null;
};
export const MaybeBrazeEpic = ({ contributionsServiceUrl, meta, countryCode, }) => {
    const componentName = meta.dataFromBraze?.componentName;
    if (componentName === 'Epic') {
        return (React.createElement(BrazeEpic, { contributionsServiceUrl: contributionsServiceUrl, meta: meta, countryCode: countryCode }));
    }
    return null;
};
